import React from "react";
import Svg, { Path, G } from "react-native-svg";

export default function QuestionIcon() {
  return (
    <Svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M12.2778 19.5C11.7032 19.5 11.1521 19.2717 10.7458 18.8654C10.3394 18.4591 10.1112 17.908 10.1112 17.3333V14.4445C10.1112 13.8698 10.3394 13.3187 10.7458 12.9124C11.1521 12.5061 11.7032 12.2778 12.2778 12.2778C12.7133 12.2735 16.6112 11.5556 16.6112 8.66668C16.6112 7.22224 15.1667 5.77779 13.0001 5.77779C11.2371 5.77779 10.1112 7.22224 10.1112 7.94446C10.1112 8.22899 10.0551 8.51073 9.94624 8.77361C9.83735 9.03648 9.67776 9.27533 9.47656 9.47652C9.27537 9.67772 9.03652 9.83731 8.77365 9.9462C8.51077 10.0551 8.22903 10.1111 7.9445 10.1111C7.65997 10.1111 7.37822 10.0551 7.11535 9.9462C6.85248 9.83731 6.61363 9.67772 6.41243 9.47652C6.21124 9.27533 6.05164 9.03648 5.94276 8.77361C5.83387 8.51073 5.77783 8.22899 5.77783 7.94446C5.77783 4.42146 9.08561 1.44446 13.0001 1.44446C18.7778 1.44446 20.9445 5.76479 20.9445 9.3889C20.9445 12.3825 19.3 14.6705 16.3129 15.8311C15.6629 16.0846 15.0201 16.2551 14.4445 16.3706V17.3333C14.4445 17.908 14.2162 18.4591 13.8099 18.8654C13.4036 19.2717 12.8525 19.5 12.2778 19.5Z"
        fill="#F34213"
      />
      <Path
        d="M12.2777 25.2778C13.4744 25.2778 14.4444 24.3077 14.4444 23.1111C14.4444 21.9145 13.4744 20.9445 12.2777 20.9445C11.0811 20.9445 10.1111 21.9145 10.1111 23.1111C10.1111 24.3077 11.0811 25.2778 12.2777 25.2778Z"
        fill="#F34213"
      />
    </Svg>
  );
}
